import { Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'

import { TransactionStatus } from '../../types/walletEnums'
import useStyles from './styles/StatusBox.styles'

interface BookingListAddFilterButtonProps {
  status: TransactionStatus
}

const StatusBox: React.FC<BookingListAddFilterButtonProps> = ({ status }) => {
  const classes = useStyles()
  const getColorForStatus = (s: TransactionStatus) => {
    switch (s) {
      case 'cancelled':
        return 'red'
        break
      case 'completed':
        return 'green'
        break
      case 'pending':
        return 'lightBlue'
      default:
        break
    }
  }
  return (
    <div className={classes.root}>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.red].join(' ')}>
          <span>{status}</span>
          <ErrorIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.green].join(' ')}>
          <span>{status}</span>
          <CheckCircleIcon />
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'lightBlue' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightBlue].join(' ')}>
          <span>{status}</span>
          <InfoIcon />
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
